const toPython_C6 = function (Blockly) {

    Blockly.Python = new Blockly.Generator("Python");
    Blockly.Python.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.Python.ORDER_ATOMIC = 0;
    Blockly.Python.ORDER_COLLECTION = 1;
    Blockly.Python.ORDER_STRING_CONVERSION = 1;
    Blockly.Python.ORDER_MEMBER = 2.1;
    Blockly.Python.ORDER_FUNCTION_CALL = 2.2;
    Blockly.Python.ORDER_EXPONENTIATION = 3;
    Blockly.Python.ORDER_UNARY_SIGN = 4;
    Blockly.Python.ORDER_BITWISE_NOT = 4;
    Blockly.Python.ORDER_MULTIPLICATIVE = 5;
    Blockly.Python.ORDER_ADDITIVE = 6;
    Blockly.Python.ORDER_BITWISE_SHIFT = 7;
    Blockly.Python.ORDER_BITWISE_AND = 8;
    Blockly.Python.ORDER_BITWISE_XOR = 9;
    Blockly.Python.ORDER_BITWISE_OR = 10;
    Blockly.Python.ORDER_RELATIONAL = 11;
    Blockly.Python.ORDER_LOGICAL_NOT = 12;
    Blockly.Python.ORDER_LOGICAL_AND = 13;
    Blockly.Python.ORDER_LOGICAL_OR = 14;
    Blockly.Python.ORDER_CONDITIONAL = 15;
    Blockly.Python.ORDER_LAMBDA = 16;
    Blockly.Python.ORDER_NONE = 99;
    Blockly.Python.ORDER_OVERRIDES = [
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_LOGICAL_NOT, Blockly.Python.ORDER_LOGICAL_NOT],
        [Blockly.Python.ORDER_LOGICAL_AND, Blockly.Python.ORDER_LOGICAL_AND],
        [Blockly.Python.ORDER_LOGICAL_OR, Blockly.Python.ORDER_LOGICAL_OR],
        [2, 1]
    ];
    Blockly.Variables.allUsedVariabless = function (a) {
        if (a instanceof Blockly.Block) var b = a.getDescendants(!1);
        else if (a instanceof Blockly.Workspace || a instanceof Blockly.WorkspaceSvg) b = a.getAllBlocks();
        else throw new Error("Not Block or Workspace: " + a);
        var c = Blockly.Variables.noVariableText();
        a = Object.create(null);
        for (var d = 0; d < b.length; d++) {
            var e = b[d].getVarModels();
            if (e)
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    // g.getId() && g.name.toLowerCase() != c && (a[g.name.toLowerCase()] = g.name)
                    if (g.getId() && g.name.toLowerCase() !== c) {
                        if (g.type === "") {
                            if (!a['']) {
                                a[''] = {}
                            }
                            a[''][g.name.toLowerCase()] = g.name
                        } else if (g.type === "list") {
                            if (!a['list']) {
                                a['list'] = {}
                            }
                            a['list'][g.name.toLowerCase()] = g.name
                        } else {

                        }
                    }
                }
        }
        let obj = {}
        for (let i in a) {
            let b = []
            for (let j in a[i]) {
                b.push(a[i][j])
            }
            obj[i] = b
        }

        // b = [];
        // for (var h in a) b.push(a[h]);
        return obj
    };
    Blockly.Python.init = function (a) {
        Blockly.Python.PASS = this.INDENT + "pass\n";
        Blockly.Python.definitions_ = Object.create(null);
        Blockly.Python.functionNames_ = Object.create(null);
        Blockly.Python.jmdstart = Object.create(null); //拿到头部文件作为最后的函数调用
        Blockly.Python.list = Object.create(null);
        Blockly.Python.IotConfig = Object.create(null);
        Blockly.Python.varibles = new Array();
        Blockly.Python.variableDB_ ? Blockly.Python.variableDB_.reset() : Blockly.Python.variableDB_ = new Blockly.Names(Blockly.Python.RESERVED_WORDS_);
        Blockly.Python.variableDB_.setVariableMap(a.getVariableMap());
        for (var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++) b.push(c[d] +
            " = 0");
        // a = Blockly.Variables.allUsedVariables(a);
        a = Blockly.Variables.allUsedVariabless(a)
        for (let i in a) {
            for (let j in a[i]) {
                let varname = a[i][j]
                if (i === "") {
                    varname = 'VAR_' + varname
                    b.push(varname + " = 0")
                } else {
                    varname = 'LIST_' + varname
                    b.push(varname + " = []")
                }
                Blockly.Python.varibles.push(varname)
            }
        }
        // for (d = 0; d < a.length; d++) {
        //     Blockly.Python.varibles.push(a[d])
        //     if (a[d].type == "lists") {
        //         b.push(a[d] + " = []")
        //     } else {
        //         b.push(a[d] + " = 0")
        //     }
        // };

        Blockly.Python.definitions_.variables = b.join("\n")
    };
    Blockly.Python.finish = function (a) {
        var b = [],
            c = [],
            f = [],
            h = [],
            d,
            l = '';
        for (d in Blockly.Python.definitions_) {
            var e = Blockly.Python.definitions_[d];
            e.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(e) : c.push(e)
        }
        //遍历有多少个头部块，就在最后添加对应的函数调用
        for (var g in Blockly.Python.jmdstart) {
            f.push(Blockly.Python.jmdstart[g] + "()")
        }

        //遍历列表的所有参数
        for (let i in Blockly.Python.list) {
            h.push(i)
            l += i + '=[]\n'
        }
        a = Blockly.Python.varibles.length > 0 ? a.replace(/\[GLOBAL]/g, "\r\n  global " + Blockly.Python.varibles.join(',')) : a.replace(/\[GLOBAL]/g, '')

        var thrad = f.length > 1 ? "import _thread\r\n" : ""
        var thradEnd = f.length > 1 ? Blockly.Python.mainEnd(f) : f.join("\r\n")

        delete Blockly.Python.definitions_;
        delete Blockly.Python.functionNames_;
        delete Blockly.Python.jmdstart;
        Blockly.Python.variableDB_.reset();
        return thrad + (b.join("\n") + "\n\n" + l + c.join("\n\n")).replace(/\n\n+/g, "\n\n").replace(/\n*$/, "\n\n") + a + "\n" + thradEnd
    };
    Blockly.Python.mainEnd = function (a) {
        let top = "def main():\r\n"
        for (let b in a) {
            top += "  _thread.start_new_thread(" + a[b].replace("()", "") + ",())\r\n"
        }
        top += "\r\nmain()\r\n\r\nwhile 1:\r\n  pass"
        return top
    };
    Blockly.Python.scrubNakedValue = function (a) {
        return a + "\n"
    };
    Blockly.Python.quote_ = function (a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = "'"; - 1 !== a.indexOf("'") && (-1 === a.indexOf('"') ? b = '"' : a = a.replace(/'/g, "\\'"));
        return b + a + b
    };
    Blockly.Python.multiline_quote_ = function (a) {
        a = a.replace(/'''/g, "\\'\\'\\'");
        return "'''" + a + "'''"
    };
    Blockly.Python.scrub_ = function (a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            if (e) {
                e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3)
                d += Blockly.Python.prefixLines(e + "\n", "# ")
            }
            // e && (e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3), d += Blockly.Python.prefixLines(e + "\n", "# "));
            for (var f = 0; f < a.inputList.length; f++) a.inputList[f].type === Blockly.INPUT_VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.Python.allNestedComments(e)) && (d += Blockly.Python.prefixLines(e, "# "))
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c =
            c ? "" : Blockly.Python.blockToCode(a);
        return d + b + c
    };
    // Blockly.Python.getAdjustedInt = function (a, b, c, d) {
    //     c = c || 0;
    //     a.workspace.options.oneBasedIndex && c--;
    //     var e = a.workspace.options.oneBasedIndex ? "1" : "0";
    //     a = Blockly.Python.valueToCode(a, b, c ? Blockly.Python.ORDER_ADDITIVE : Blockly.Python.ORDER_NONE) || e;
    //     Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
    //     return a
    // };
    Blockly.Python.transformColor = function (color) {
        var colors = color.slice(1)
        var newColors = ''
        for (var j = 0; j < colors.length; j++) {
            if (colors[j] !== '0') {
                newColors = colors.slice(j)
                break;
            } else if (colors == '000000') {
                newColors = '0'
                break;
            }
        }
        var newColor = '';
        for (var i = 0; i < newColors.length; i++) {
            newColor += newColors[i].toLocaleUpperCase()
        }
        return '0x' + newColor

    }

    Blockly.Python.matrixToString16 = function (matrix) {
        let arr = []
        for (var i = 0; i < matrix.length;) {
            // 字符串翻转
            var length = (matrix.slice(i, i + 8)).length;
            length = length - 1;
            var newstr = ''
            for (var x = length; x >= 0; x--) {
                newstr += (matrix.slice(i, i + 8)).charAt(x);
            }

            arr.push(newstr)
            i += 8
        }
        let value = ''
        for (var j = 0; j < arr.length; j++) {
            let temp = parseInt(arr[j], 2)
            temp = temp.toString(16)
            // 十六进制，不够两位补0
            let zero = '00';
            let tmp = 2 - temp.length;
            value += zero.substr(0, tmp) + temp;

        }
        return value
    }



    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------





    Blockly.Python.pass = "    pass\n";

    Blockly.Python.jmd_start = function (a) {
        let task = a.getFieldValue("TASK");
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        Blockly.Python.jmdstart[a.id] = task;
        Blockly.Python.definitions_.RCU = "import rcu";
        return "def " + task + "():[GLOBAL]\r\n" + passEnd;
    };
    Blockly.Python.jmd_getLeftButton = function (a) {
        return ["rcu.GetLeftButton()", 1];
    };
    Blockly.Python.jmd_getRightButton = function (a) {
        return ["rcu.GetRightButton()", 1];
    };
    Blockly.Python.jmd_getInMic = function (a) {
        return ["rcu.GetInMic()", 1];
    };
    Blockly.Python.jmd_getBatteryVoltage = function (a) {
        return ["rcu.GetInVotage()", 1];
    };
    Blockly.Python.jmd_getControlTime = function (a) {
        return ["rcu.GetSysTime()", 1];
    };
    Blockly.Python.jmd_setControlTimeZero = function (a) {
        return "  rcu.SetSysTime()\r\n";
    };
    Blockly.Python.jmd_setBeep = function (a) {
        let state = a.getFieldValue("STATE");
        return "  rcu.SetInBeep(" + state + ")\r\n";
    };
    Blockly.Python.jmd_setInSound = function (a) {
        let frequency = a.getFieldValue("FREQUENCY");
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetInSound(" + frequency + ",(" + time + " * 1000))\r\n";
    };
    Blockly.Python.jmd_getData = function (a) {
        return ["rcu.GetData(" + Blockly.Python.valueToCode(a, "ADDRESS", 2) + ")", 1];
    };
    Blockly.Python.jmd_setData = function (a) {
        let address = Blockly.Python.valueToCode(a, "ADDRESS", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  rcu.SetData(" + address + "," + value + ")\r\n";
    };

    Blockly.Python.jmd_setUartData = function (a, b, c) {
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        let baudRate = a.getFieldValue("BAUDRATE");
        return `  rcu.SetUartData(${data},${baudRate})\r\n`;
    };
    Blockly.Python.jmd_getUartData = function (a, b, c) {
        let baudRate = a.getFieldValue("BAUDRATE");
        return [`rcu.GetUartData(${baudRate})`, 1];
    };
    
    Blockly.Python.control_RunPython = function (a, b, c) {
        let command = Blockly.Python.valueToCode(a, "COMMAND", 2);
        command = command.replace(/^[\"\']/ig, "").replace(/[\"\']$/ig, "")
        if (command !== "") {
            command = `  ${command}\r\n`
        }
        return `${command}`;
    };




    //马达

    Blockly.Python.motor_setMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  motor.SetMotor(" + motorport + "," + value + ")\r\n";
    };
    Blockly.Python.motor_getMotorCode = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport = a.getFieldValue("MOTORPORT");
        return ["motor.GetMotorCode(" + motorport + ")", 1];
    };
    Blockly.Python.motor_setMotorCode = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport = a.getFieldValue("MOTORPORT");
        return "  motor.SetMotorCode(" + motorport + ")\r\n";
    };
    Blockly.Python.motor_setServoMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetMotorServo(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_waitServomotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetWaitForAngle(" + motorport + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setLinearSpeed = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let pulse = Blockly.Python.valueToCode(a, "PULSE", 2);
        return "  motor.SetMotorStraightAngle(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.Python.motor_setTurnSpeed = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport1 = a.getFieldValue("PORT1");
        let motorport2 = a.getFieldValue("PORT2");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let pulse = Blockly.Python.valueToCode(a, "PULSE", 2);
        return "  motor.SetCarTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + pulse + ")\r\n";
    };
    Blockly.Python.motor_setMotorPower = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorone = Blockly.Python.valueToCode(a, "MOTORONE", 2);
        let motortwo = Blockly.Python.valueToCode(a, "MOTORTWO", 2);
        let motorthree = Blockly.Python.valueToCode(a, "MOTORTHREE", 2);
        let motorfour = Blockly.Python.valueToCode(a, "MOTORFOUR", 2);
        return "  motor.SetMotorPower(" + motorone + "," + motortwo + "," + motorthree + "," + motorfour + ")\r\n";
    };
    Blockly.Python.motor_setMotorStraight = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        return "  motor.SetMotorStraight(" + motorport1 + "," + motorport2 + "," + speed + ")\r\n";
    };
    Blockly.Python.motor_setMotorStraightTurn = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let motorport1 = a.getFieldValue("MOTORPORTONE");
        let motorport2 = a.getFieldValue("MOTORPORTTWO");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetMotorStraightTurn(" + motorport1 + "," + motorport2 + "," + speed + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServoTime = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  motor.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.Python.motor_setServo_E6 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo_OS = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServoTime_E6 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  motor.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };

    Blockly.Python.motor_setSteeringRelease = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        return `  motor.setSteeringRelease(${port})\r\n`;
    };
    Blockly.Python.motor_setSteeringAngle = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        return `  motor.setSteeringAngle(${port},${angle})\r\n`;
    };

    Blockly.Python.motor_stopMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        return `  motor.stopMotor(${port})\r\n`;
    };
    Blockly.Python.motor_setMotorVByOther = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let model = a.getFieldValue("MODEL");
        return `  motor.setMotorVByOther(${port},${speed},${angle},"${model}")\r\n`;
    };
    Blockly.Python.motor_waitMotorTo = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let model = a.getFieldValue("MODEL");
        return `  motor.waitMotorTo(${port},${speed},${angle},"${model}")\r\n`;
    };

    Blockly.Python.E6_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  motor.SetMagneticServoDegreeTime(${port},${angle},${time})\r\n`;
    };
    Blockly.Python.E6_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  motor.SetMagneticServoDegreeSpeed(${port},${angle},${speed})\r\n`;
    };
    Blockly.Python.E6_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  motor.SetMagneticServoCodeMotor(${port},${angle},${speed})\r\n`;
    };

    Blockly.Python.E3_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  motor.SetMagneticServoDegreeTime(${port},${angle},${time})\r\n`;
    };
    Blockly.Python.E3_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  motor.SetMagneticServoDegreeSpeed(${port},${angle},${speed})\r\n`;
    };
    Blockly.Python.E3_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  motor.SetMagneticServoCodeMotor(${port},${angle},${speed})\r\n`;
    };

    Blockly.Python.E6_motor_setSeeringEngine = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        return `  motor.SetSeeringEngine(${port},${angle})\r\n`;
    };
    Blockly.Python.E3_motor_setSeeringEngine = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        return `  motor.SetSeeringEngine(${port},${angle})\r\n`;
    };
    Blockly.Python.E6_motor_setSeeringEngineTime = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  motor.SetSeeringEngineTime(${port},${angle},${time})\r\n`;
    };
    Blockly.Python.E3_motor_setSeeringEngineTime = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  motor.SetSeeringEngineTime(${port},${angle},${time})\r\n`;
    };


    //M6 RCU 马达特有的积木块

    Blockly.Python.motor_setServoMotor48 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetMotorServo(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_waitServomotor48 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetWaitForAngle(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_setServoMotor128 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetMotorServo128(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_waitservomotor128 = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetWaitForAngle128(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    
    Blockly.Python.M6_motor_setServoMotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetMotorServo(" + prop + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.M6_motor_waitservomotor = function (a, b, c) {
        Blockly.Python.definitions_.MOTOR = "import motor";
        let prop = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  motor.SetWaitForAngle(" + prop + "," + speed + "," + angle + ")\r\n";
    };


    //舵机
    
    Blockly.Python.motor_setServo_M6 = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  servo.SetServo(" + prop + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_setServoTime_M6 = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  servo.SetServoTime(" + prop + "," + angle + "," + time + ")\r\n";
    };
    Blockly.Python.M6_motor_setMagneticServoDegreeTime = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  servo.SetMagneticServoDegreeTime(${port},${angle},${time})\r\n`;
    };
    Blockly.Python.M6_motor_setMagneticServoDegreeSpeed = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  servo.SetMagneticServoDegreeSpeed(${port},${angle},${speed})\r\n`;
    };
    Blockly.Python.M6_motor_setMagneticServoCodeMotor = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  servo.SetMagneticServoCodeMotor(${port},${angle},${speed})\r\n`;
    };
    Blockly.Python.M6_motor_setSeeringEngine = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        return `  servo.SetSeeringEngine(${port},${angle})\r\n`;
    };
    Blockly.Python.M6_motor_setSeeringEngineTime = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let port = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  servo.SetSeeringEngineTime(${port},${angle},${time})\r\n`;
    };

    Blockly.Python.motor_setOneServo = function (a, b, c) {
        Blockly.Python.definitions_.SERVO = "import servo";
        let prop = a.getFieldValue("PORT");
        let channel = Blockly.Python.valueToCode(a, "CHANNEL", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  servo.SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ")\r\n";
    };


    //控制
    Blockly.Python.math_positive_number = function (a) {
        let num = a.getFieldValue('NUM');
        return [num, 1];
    };
    Blockly.Python.control_wait = function (a) {
        let time = Blockly.Python.valueToCode(a, "DURATION", 2);
        return "  rcu.SetWaitForTime(" + time + ")\r\n";
    };
    Blockly.Python.control_repeat = function (block) {
        let time = Blockly.Python.valueToCode(block, "TIMES", 2);
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = branch ? (Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass) : Blockly.Python.pass;
        return "  for count in range(" + time + "):\r\n" + branch;
    };
    Blockly.Python.control_forever = function (block) {
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  while True:\r\n" + branch;
    };
    Blockly.Python.control_if = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  if " + bool + ":\r\n" + branch;
    };
    Blockly.Python.control_if_else = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch1 = Blockly.Python.statementToCode(block, "SUBSTACK", 2);
        branch1 = Blockly.Python.addLoopTrap(branch1, branch1) || Blockly.Python.pass;
        let branch2 = Blockly.Python.statementToCode(block, "SUBSTACK2");
        branch2 = Blockly.Python.addLoopTrap(branch2, branch2) || Blockly.Python.pass;
        return "  if " + bool + ":\r\n" + branch1 + "  else:\r\n" + branch2;
    };
    Blockly.Python.control_wait_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        return "  while not(" + bool + "):\r\n    pass\r\n";
    };
    Blockly.Python.control_repeat_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "  while not(" + bool + "):\r\n" + branch;
    };

    Blockly.Python.control_stopPy = function (block) {
        let cmd = block.getFieldValue("CMD");
        return `  rcu.stopPy("${cmd}")\r\n`;
    };

    //传感器

    Blockly.Python.sensor_getTouch = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        return ["sensor.GetTouch(" + prop + ")", 1];
    };
    Blockly.Python.sensor_colorDetection = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("COLORPORT");
        return ["sensor.GetColorSensor(" + prop + ",4)", 1];
    };
    Blockly.Python.sensor_getUltrasonic = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("ULTRASONICPORT");
        return ["sensor.GetUltrasound(" + prop + ")", 1];
    };
    Blockly.Python.sensor_getUltrasonicCompare = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        return [`sensor.GetUltrasound(${port}) ${mode} ${data}`, 2];
    };
    
    Blockly.Python.sensor_colorDetectionCompare = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        return [`sensor.GetColorSensor(${port}, 4) == ${mode}`, 2];
    };

    Blockly.Python.sensor_colorDetectionMode = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let mode = a.getFieldValue("MODE");
        return [`sensor.GetColorSensor(${port}, ${mode})`, 1];
    };
    


    Blockly.Python.sensor_getLightSensor = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        return ["sensor.GetLightSensor(" + prop + ")", 1];
    };
    Blockly.Python.sensor_getLightSensorDigital = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        return ["sensor.GetLightSensorData(" + prop + ")", 1];
    };
    Blockly.Python.sensor_setLightSensor = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let state = a.getFieldValue("STATE");
        return "  sensor.SetLightSensorLed(" + prop + "," + state + ")\r\n";
    };
    Blockly.Python.sensor_setColorLamp = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return "  sensor.Set3CLed(" + prop + "," + color + ")\r\n";
    };
    Blockly.Python.sensor_getgesture = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("PORT");
        return ["sensor.GetGesture(" + prop + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamRockCtrlNew = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let rockctrl = a.getFieldValue("ROCKCTRL");
        return ["sensor.GetWifiCamRockCtrlNew(" + rockctrl + ")", 1];
    };
    Blockly.Python.sensor_getWifiPictureData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let rockctrl = a.getFieldValue("PICTURE");
        return ["sensor.GetWifiPictureData(" + rockctrl + ")", 1];
    };
    Blockly.Python.sensor_getCamRecogData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        return ["sensor.GetCamRecog(" + data + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureResult = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let camdata = a.getFieldValue("CAMDATA");
        return ["sensor.GetWifiCamPictureResult(" + camdata + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureSize = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let size = a.getFieldValue("SIZE");
        return ["sensor.GetWifiCamPictureSize(" + size + ")", 1];
    };
    Blockly.Python.sensor_getWifiCamPictureSite = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let site = a.getFieldValue("SITE");
        return ["sensor.GetWifiCamPictureSite(" + site + ")", 1];
    };
    Blockly.Python.sensor_setLizard = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let color = a.getFieldValue("COLOR");
        return "  sensor.SetLizard(" + color + ")\r\n";
    };
    Blockly.Python.sensor_getRFID = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return ["sensor.GetRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_ReadRFIDData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return ["sensor.ReadRFID522(" + port + ")", 1];
    };

    Blockly.Python.sensor_WriteRFIDData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.Python.valueToCode(a, "DATA", 2)
        return "  sensor.WriteRFID522(" + port + "," + data + ")\r\n";
    };

    // M6 RCU 传感器特有的积木块

    Blockly.Python.sensor_getRFID2 = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return ["sensor.GetRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_ReadRFIDData2 = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return ["sensor.ReadRFID522(" + port + ")", 1];
    };
    Blockly.Python.sensor_WriteRFIDData2 = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let data = Blockly.Python.valueToCode(a, "DATA", 2)
        return "  sensor.WriteRFID522(" + port + "," + data + ")\r\n";
    };



    Blockly.Python.sensor_getColorRgb = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return [`sensor.getColorRgb(${port},"${color}")`, 1];
    };
    Blockly.Python.sensor_isColor = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let color = a.getFieldValue("COLOR");
        return [`sensor.isColor(${port},"${color}")`, 1];
    };
    Blockly.Python.sensor_waitNewColor = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        return `  sensor.waitNewColor(${port})\r\n`;
    };
    Blockly.Python.sensor_waitThisColor = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let color = a.getFieldValue("COLOR");
        return `  sensor.waitThisColor(${port},"${color}")\r\n`;
    };
    Blockly.Python.sensor_getColorLevelGgb = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let color = a.getFieldValue("COLOR");
        return [`sensor.getColorLevelGgb(${port},"${color}")`, 1];
    };
    Blockly.Python.sensor_isUltra = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`sensor.isUltra(${port},"${status}",${value})`, 1];
    };
    Blockly.Python.sensor_isElectedData = function (a, b, c) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let status = a.getFieldValue("STATUS");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`sensor.isElectedData(${port},"${status}",${value})`, 1];
    };

    Blockly.Python.sensor_getEleLightIfData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        return [`sensor.getEleLightIfData(${port})`, 1];
    };
    Blockly.Python.sensor_setElcLightIfData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("PORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return `  sensor.setElcLightIfData(${port},${value})\r\n`;
    };





    //AI

    Blockly.Python.sensor_setAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "  rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };

    Blockly.Python.sensor_getAICamData = function (a) {
        let data = a.getFieldValue("DATA");
        return ["rcu.GetAICamData(" + data + ")", 1];
    };
    Blockly.Python.sensor_setWaitForAICamData = function (a) {
        let aimode = a.getFieldValue("AIMODE");
        let aimode2 = a.getFieldValue("AIMODE2") ? a.getFieldValue("AIMODE2") : 0;
        return "  rcu.SetWaitForAICamData(" + aimode + "," + aimode2 + ")\r\n";
    };
    Blockly.Python.sensor_getAICamDataColorDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataQR = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataBall = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataRoad = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataFaceDetect = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataImage = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataImageLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataGesture = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataApriltag = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataTraffic = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataColorLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataFaceLearning = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamVoice = function (a) {
        let order = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + order + ")", 1];
    };
    Blockly.Python.sensor_getAIBrainData = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataForest = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataLeftWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };
    Blockly.Python.sensor_getAICamDataRightWidth = function (a) {
        let color = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + color + ")", 1];
    };

    Blockly.Python.AI_getZxing = function (a) {
        return ["rcu.getZxing()", 1];
    }
    Blockly.Python.AI_setZxing = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 16);
        return "  rcu.setZxing(" + data + ");\r\n"
    }
    Blockly.Python.AI_getWeather = function (a) {
        let city = Blockly.Python.valueToCode(a, "city", 16);
        console.log(city)
        return ["rcu.getWeather(" + city + ")", 1]
    }
    Blockly.Python.AI_getPostAngel = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);
        return [`rcu.getPostAngel(${value})`, 1]
    }

    Blockly.Python.AI_getPost = function (a) {
        let fnName = a.getFieldValue("FNNAME");
        let POST = a.getFieldValue("POST");

        return [`rcu.${fnName}${POST}()`, 1]
    }
    Blockly.Python.AI_getResult = function (a) {
        let fnName = a.getFieldValue("FNNAME");

        return [`rcu.${fnName}()`, 1]
    }
    Blockly.Python.AI_startCamera = function (a) {
        let fnName = a.getFieldValue("FNNAME");

        return `  rcu.startCamera("${fnName}")\r\n`;
    }

    Blockly.Python.AI_getFaceResult = function (a) {
        return [`rcu.getFaceResult()`]
    }
    Blockly.Python.AI_isFaceResult = function (a) {
        let data = Blockly.Python.valueToCode(a, "DATA", 16);

        return [`rcu.isFaceResult(${data})`]
    }

    Blockly.Python.AI_getMFColor = function (a) {
        let value = Blockly.Python.valueToCode(a, "VALUE", 16);

        return [`rcu.getMFColor(${value})`, 1]
    }
    Blockly.Python.AI_setStartMF = function (a) {
        let VALUE = a.getFieldValue("VALUE");

        return `  rcu.setStartMF("${VALUE}")\r\n`
    }

    Blockly.Python.AI_isFingerResult = function (a) {
        let FINGER = a.getFieldValue("FINGER");

        return [`rcu.isFingerResult("${FINGER}")`]
    }
    Blockly.Python.AI_isTraficResult = function (a) {
        let TRAFIC = a.getFieldValue("TRAFIC");

        return [`rcu.isTraficResult("${TRAFIC}")`]
    }

    Blockly.Python.AI_getVoiceData = function (a) {
        return [`rcu.getVoiceData()`]
    }



    //显示

    Blockly.Python.show_getTouchScreen = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        return ["display.GetTouchScreen()", 1];
    };
    Blockly.Python.show_getTouchScreenX = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        return ["display.GetTouchScreenX()", 1];
    };
    Blockly.Python.show_getTouchScreenY = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        return ["display.GetTouchScreenY()", 1];
    };
    Blockly.Python.show_LCDClearScreen = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let color = a.getFieldValue("COLOR");
        return "  display.SetLCDClear(" + color + ")\r\n";
    };
    Blockly.Python.show_M6SetLCDBack = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let status = a.getFieldValue("STATUS");
        return "  display.SetLCDBack(" + status + ")\r\n";
    };
    
    Blockly.Python.show_SetFontSize = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let fontsize = a.getFieldValue("FONTSIZE");
        return "  display.SetFontSize(" + fontsize + ")\r\n";
    };
    Blockly.Python.show_setLineNum = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let lines = Blockly.Python.valueToCode(a, "LINES", 2);
        let linenumber = Blockly.Python.valueToCode(a, "LINENUMBER", 2);
        return "  display.SetDisplayVar(" + lines + "," + linenumber + ",0xFFE0,0x0000)\r\n";
    };
    Blockly.Python.show_setColor = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let lines = Blockly.Python.valueToCode(a, "LINES", 2);
        let text = Blockly.Python.valueToCode(a, "TEXT", 99);
        if (text.search(/^\s{0,}$/ig) == 0) {
            text = '"' + text + '"'
        }
        text = a.getInputTargetBlock("TEXT") ? a.getInputTargetBlock("TEXT").isShadow_ ? text : "str(" + text + ")" : ""

        return "  display.SetDisplayString(" + lines + "," + text + ",0xFFE0,0x0000)\r\n";
    };
    Blockly.Python.show_drawImage = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "IMAGEX", 2);
        let y = Blockly.Python.valueToCode(a, "IMAGEY", 2);
        let filename = Blockly.Python.valueToCode(a, "IMAGEFILENAME", 2);
        let scale = Blockly.Python.valueToCode(a, "IMAGESCALE", 2);
        return "  display.SetDisplayPicture(" + x + "," + y + "," + filename + "," + scale + ")\r\n";
    };
    Blockly.Python.show_diplayData = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "X", 2);
        let y = Blockly.Python.valueToCode(a, "Y", 2);
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        return "  display.SetDisplayVarXY(" + x + "," + y + "," + data + "," + color + "," + backgroundcolor + ")\r\n";
    };
    Blockly.Python.show_displayCharacter = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "X", 2);
        let y = Blockly.Python.valueToCode(a, "Y", 2);

        let text = Blockly.Python.valueToCode(a, "CHARACTER", 99);
        text = a.getInputTargetBlock("CHARACTER") ? a.getInputTargetBlock("CHARACTER").isShadow_ ? text : "str(" + text + ")" : ""

        let color = a.getFieldValue("COLOR");
        let backgroundcolor = a.getFieldValue("BACKGROUNDCOLOR");
        let transparent = a.getFieldValue("TRANSPARENT");
        return "  display.SetDisplayStringXY(" + x + "," + y + "," + text + "," + color + "," + backgroundcolor + "," + transparent + ")\r\n";
    };
    Blockly.Python.show_drawPoint = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "POINTX", 2);
        let y = Blockly.Python.valueToCode(a, "POINTY", 2);
        let color = a.getFieldValue("POINTCOLOR");
        return "  display.SetLCDDot(" + x + "," + y + "," + color + ")\r\n";
    };
    Blockly.Python.show_drawLine = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "LINEX", 2);
        let y = Blockly.Python.valueToCode(a, "LINEY", 2);
        let lineangle = Blockly.Python.valueToCode(a, "LINEANGLE", 2);
        let linelength = Blockly.Python.valueToCode(a, "LINELENGTH", 2);
        let color = a.getFieldValue("LINECOLOR");
        return "  display.SetLCDLine(" + x + "," + y + "," + lineangle + "," + linelength + "," + color + ")\r\n";
    };
    Blockly.Python.show_drawCircle = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "CIRCLEX", 2);
        let y = Blockly.Python.valueToCode(a, "CIRCLEY", 2);
        let circleradius = Blockly.Python.valueToCode(a, "CIRCLERADIUS", 2);
        let color = a.getFieldValue("CIRCLECOLOR");
        return "  display.SetLCDSolidCircle(" + x + "," + y + "," + circleradius + "," + color + ")\r\n";
    };
    Blockly.Python.show_drawRectangle = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "RECTANGLEX", 2);
        let y = Blockly.Python.valueToCode(a, "RECTANGLEY", 2);
        let rectanglewitdh = Blockly.Python.valueToCode(a, "RECTANGLEWIDTH", 2);
        let rectangleheight = Blockly.Python.valueToCode(a, "RECTANGLEHEIGHT", 2);
        let rectanglelinewidth = Blockly.Python.valueToCode(a, "RECTANGLELINEWIDTH", 2);
        let color = a.getFieldValue("RECTANGLECOLOR");
        return "  display.SetLCDRectangle2(" + x + "," + y + "," + rectanglewitdh + "," + rectangleheight + "," + rectanglelinewidth + "," + color + ")\r\n";
    };
    Blockly.Python.show_drawSolidRectangle = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEX", 2);
        let y = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEY", 2);
        let solidrectanglewidth = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEWIDTH", 2);
        let solidrectangleheight = Blockly.Python.valueToCode(a, "SOLIDRECTANGLEHEIGHT", 2);
        let color = a.getFieldValue("SOLIDRECTANGLECOLOR");
        return "  display.SetLCDFilledRectangle2(" + x + "," + y + "," + solidrectanglewidth + "," + solidrectangleheight + "," + color + ")\r\n";
    };


    Blockly.Python.show_setPaintColor = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let color = a.getFieldValue("COLOR");
        return `  display.setPaintColor("${color}")\r\n`;
    };
    Blockly.Python.show_setDisplayStringXYS = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let x = Blockly.Python.valueToCode(a, "X", 16);
        let y = Blockly.Python.valueToCode(a, "Y", 16);
        let text = Blockly.Python.valueToCode(a, "TEXT", 16);
        return `  display.setDisplayStringXYS(${x},${y},${text})\r\n`;
    };
    Blockly.Python.show_setDisplayVarU32 = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let line = Blockly.Python.valueToCode(a, "LINE", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        let fontColor = a.getFieldValue("FONTCOLOR");
        let bgColor = a.getFieldValue("BGCOLOR");
        return `  display.SetDisplayVarU32(${line},${value},${fontColor},${bgColor})\r\n`;
    };
    Blockly.Python.show_setDisplayFloat = function (a) {
        Blockly.Python.definitions_.DISPLAY = "import display";
        let line = Blockly.Python.valueToCode(a, "LINE", 2);
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        let fontColor = a.getFieldValue("FONTCOLOR");
        let bgColor = a.getFieldValue("BGCOLOR");
        return `  #display.SetDisplayFloat(${line},${value},${fontColor},${bgColor}) //python未实现\r\n`;
    };




    //无线
    Blockly.Python.wireless_getRCUBleData = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        return ["wireless.GetBluetoothData()", 1];
    };
    Blockly.Python.wireless_RCUSendBluetoothData = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let data = Blockly.Python.valueToCode(a, "DATA", 2);
        return "  wireless.SetBluetoothData(" + data + ")\r\n";
    };
    Blockly.Python.wireless_getComVoice = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let text = Blockly.Python.valueToCode(a, "TEXT", 2);
        return ["wireless.GetComVoice(" + text + ")", 1];
    };
    Blockly.Python.wireless_getBluetoothControl = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        return ["wireless.GetBluetoothControl()", 1];
    };
    Blockly.Python.wireless_getBluetoothControlData = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        return ["wireless.GetBluetoothControlData()", 1];
    };
    Blockly.Python.wireless_getBluetoothButton = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        return ["wireless.GetBTModuleRemoteButton()", 1];
    };
    Blockly.Python.wireless_getBluetoothCode = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        return ["wireless.GetBTModuleRemoteCode()", 1];
    };
    Blockly.Python.wireless_getBluetoothRocker = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let direction = a.getFieldValue("DIRECTION");
        let axis = a.getFieldValue("AXIS");
        return ["wireless.GetBTModuleRemoteRocker(" + direction + "," + axis + ")", 1];
    };



    // 扩展： 传感器
    Blockly.Python.extSensor_setAttitude = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SETATTITUDEMODE");
        return "  sensor.SetAHRS(" + arg1 + "," + arg2 + ")\r\n";
    };
    Blockly.Python.extSensor_getAttitude = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("ATTITUDEMODE");
        return ["sensor.GetAHRS(" + arg1 + "," + arg2 + ",0)", 1];
    };

    Blockly.Python.extSensor_LaserDist = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("LASERDISTMODE");
        return ["sensor.GetLaserDist(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_ShortIRDist = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["sensor.GetShortIRDist(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_Gesture = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["sensor.GetGesture(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getAirPressure = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["sensor.GetAirPressure(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getSht30 = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("COMMAND");
        return ["sensor.GetSht30(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getMagnetic = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("MODEL");
        return ["sensor.GetMagnetic(" + arg1 + "," + arg2 + ")", 1];
    };
    Blockly.Python.extSensor_sensor_getScanCamera = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        return ["sensor.GetScanCamera()", 1];
    };
    Blockly.Python.extSensor_sensor_getComStrCompare = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return [`sensor.GetComStrCompare(${value})`, 1];
    };
    Blockly.Python.extSensor_smartEyeDist = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["sensor.GetSmartEyeDist(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_smartEyeIRCode = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return ["sensor.GetSmartEyeIRcode(" + arg1 + ")", 1];
    };
    Blockly.Python.extSensor_setSmartEyeIRCode = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "  sensor.SetSmartEyeIRcode(" + arg1 + "," + arg2 + ")\r\n";
    };
    Blockly.Python.extSensor_setSmartEye = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("SMARTEYEMODE");

        let arg3 = Blockly.Python.valueToCode(a, "COLOR", 2);
        arg3 = Blockly.Python.transformColor(arg3) //转换成 0x的形式

        return "  sensor.SetSmartEyeMode(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_setSmartEyeAllLed = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "COLOR1", 2);
        arg2 = Blockly.Python.transformColor(arg2) //转换成 0x的形式

        let arg3 = Blockly.Python.valueToCode(a, "COLOR2", 2);
        arg3 = Blockly.Python.transformColor(arg3) //转换成 0x的形式

        let arg4 = Blockly.Python.valueToCode(a, "COLOR3", 2);
        arg4 = Blockly.Python.transformColor(arg4) //转换成 0x的形式

        let arg5 = Blockly.Python.valueToCode(a, "COLOR4", 2);
        arg5 = Blockly.Python.transformColor(arg5) //转换成 0x的形式

        let arg6 = Blockly.Python.valueToCode(a, "COLOR5", 2);
        arg6 = Blockly.Python.transformColor(arg6) //转换成 0x的形式

        let arg7 = Blockly.Python.valueToCode(a, "COLOR6", 2);
        arg7 = Blockly.Python.transformColor(arg7) //转换成 0x的形式

        let arg8 = Blockly.Python.valueToCode(a, "COLOR7", 2);
        arg8 = Blockly.Python.transformColor(arg8) //转换成 0x的形式

        let arg9 = Blockly.Python.valueToCode(a, "COLOR8", 2);
        arg9 = Blockly.Python.transformColor(arg9) //转换成 0x的形式

        return "  sensor.SetSmartEyeAllLed(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + "," + arg6 + "," + arg7 + "," + arg8 + "," + arg9 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeClear = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");
        return "  sensor.SetDisplayLatticeClear(" + arg1 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticePic = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "MATRIX", 2);
        arg2 = '"' + Blockly.Python.matrixToString16(arg2) + '"'

        let arg3 = a.getFieldValue("LIGHTNESS");

        return "  sensor.SetDisplayLatticePic(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLattice = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "VALUE", 99);
        arg2 = a.getInputTargetBlock("VALUE") ? a.getInputTargetBlock("VALUE").isShadow_ ? arg2 : "str(" + arg2 + ")" : ""

        let arg3 = a.getFieldValue("LIGHTNESS");
        return "  sensor.SetDisplayLattice(" + arg1 + "," + arg2 + "," + arg3 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeXY = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";

        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "X", 2);
        let arg3 = Blockly.Python.valueToCode(a, "Y", 2);
        let arg4 = a.getFieldValue("STATES");
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "  sensor.SetDisplayLatticeXY(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ")\r\n";
    };
    Blockly.Python.extSensor_SetDisplayLatticeString = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let arg1 = a.getFieldValue("SENSORPORT");

        let arg2 = Blockly.Python.valueToCode(a, "STRING", 99);
        arg2 = a.getInputTargetBlock("STRING") ? a.getInputTargetBlock("STRING").isShadow_ ? arg2 : "str(" + arg2 + ")" : ""

        let arg3 = a.getFieldValue("DIRECTION");
        let arg4 = Blockly.Python.valueToCode(a, "SPEED", 2);
        let arg5 = a.getFieldValue("LIGHTNESS");

        return "  sensor.SetDisplayLatticeString(" + arg1 + "," + arg2 + "," + arg3 + "," + arg4 + "," + arg5 + ")\r\n";
    };

    Blockly.Python.extSensor_sensor_getTraceV2I2C = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let cmd = a.getFieldValue("PASSAGEWAY");
        return [`sensor.GetTraceV2I2C(${port},${cmd})`, 1]
    };

    Blockly.Python.extSensor_sensor_getTraceV2I2CState = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let cmd = a.getFieldValue("STATEDATA");
        return [`sensor.GetTraceV2I2CState(${port},${cmd})`, 1]
    };


    
    Blockly.Python.extSensor_sensor_M5_getTraceV2I2CState = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let channel = Blockly.Python.valueToCode(a, "CHANNEL", 2);
        return [`sensor.GetTraceV2I2CState(${prop},${channel})`, 1];
    };
    Blockly.Python.extSensor_sensor_M5_GetTraceV2I2CChxState = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let status = a.getFieldValue("INTERSECTIONSTATUS");
        return [`sensor.GetTraceV2I2CChxState(${prop},${status})`, 1];
    };
    Blockly.Python.extSensor_sensor_M5_SetTraceV2I2Color = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let color1 = Blockly.Python.valueToCode(a, "COLOUR1", 2);
        let color2 = Blockly.Python.valueToCode(a, "COLOUR2", 2);
        let color3 = Blockly.Python.valueToCode(a, "COLOUR3", 2);
        let color4 = Blockly.Python.valueToCode(a, "COLOUR4", 2);
        let color5 = Blockly.Python.valueToCode(a, "COLOUR5", 2);
        let color6 = Blockly.Python.valueToCode(a, "COLOUR6", 2);
        let color7 = Blockly.Python.valueToCode(a, "COLOUR7", 2);
        return `  sensor.SetTraceV2I2Color(${prop},${color1},${color2},${color3},${color4},${color5},${color6},${color7})\r\n`;
    };
    Blockly.Python.extSensor_sensor_M5_SetTraceV2I2AllColor = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let color = Blockly.Python.valueToCode(a, "COLOUR", 2);
        return `  sensor.SetTraceV2I2AllColor(${prop},${color})\r\n`;
    };
    Blockly.Python.extSensor_sensor_M5_SetTraceV2I2Threshold = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let seconds = Blockly.Python.valueToCode(a, "SECONDS", 2);
        return `  sensor.SetTraceV2I2Threshold(${prop},${seconds})\r\n`;
    };
    Blockly.Python.extSensor_sensor_M5_SetTraceV2I2CLineColor = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let prop = a.getFieldValue("SENSORPORT");
        let color = Blockly.Python.valueToCode(a, "COLOUR", 2);
        return `  sensor.SetTraceV2I2CLineColor(${prop},${color})\r\n`;
    };

    
    Blockly.Python.extSensor_menu_CHANNELMENUS = function (a) {
        let channel = a.getFieldValue("CHANNELMENUS") || "";
        return [channel, 1];
    };
    Blockly.Python.extSensor_menu_INTERSECTIONSTATUS = function (a) {
        let colours = a.getFieldValue("INTERSECTIONSTATUS") || "";
        return [colours, 1];
    };
    Blockly.Python.extSensor_menu_colorMenus = function (a) {
        let colours = a.getFieldValue("colorMenus") || "";
        return [colours, 1];
    };
    Blockly.Python.extSensor_menu_colorMenus2 = function (a) {
        let colours = a.getFieldValue("colorMenus2") || "";
        return [colours, 1];
    };


    
    Blockly.Python.extIot_SetIOTConfig = function (a) {
        Blockly.Python.definitions_.IOT = "import IOT";
        
        let config = a.getFieldValue("CONFIG");
        let cmd = []
        config = JSON.parse(config)
        let port = a.getFieldValue("SENSORPORT");
        cmd.push(`  IOT.SetIOTConfig(${port},"${config.wifi_name}","${config.wifi_pwd}","${config.iot_id}","${config.iot_pwd}","${config.server_ip}")\r\n`)
        
        for(let i=0; i < config.Topics.length; i++){
            cmd.push(`  IOT.SetIOTTopic(${port},"${config.Topics[i]}")\r\n`)
        }
        Blockly.Python.IotConfig[port] = config.Topics
        
        return cmd.join("");
    };

    
    Blockly.Python.extIot_GetIOTData = function (a) {
        Blockly.Python.definitions_.IOT = "import IOT";

        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2) || '""';
        if(!isNaN(Number(value))){
            value = `"${value}"`
        }

        let data = ""
        if(Blockly.Python.IotConfig[port]){
            let topicData = Blockly.Python.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        
        return [`IOT.GetIOTData(${port},"${data}",${value})`, 1]
    };

    Blockly.Python.extIot_SetIOTData = function (a) {
        Blockly.Python.definitions_.IOT = "import IOT";

        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.Python.valueToCode(a, "DATA", 2) || "";

        let data = ""
        if(Blockly.Python.IotConfig[port]){
            let topicData = Blockly.Python.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        
        return `  IOT.SetIOTData(${port},"${data}",${value})\r\n`
    };
    Blockly.Python.extIot_SetIOTDataStr = function (a) {
        Blockly.Python.definitions_.IOT = "import IOT";

        let topicIndex = a.getFieldValue("TOPIC");
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.Python.valueToCode(a, "DATA", 2);

        let data = ""
        if(Blockly.Python.IotConfig[port]){
            let topicData = Blockly.Python.IotConfig[port]
            if(topicData[topicIndex]){
                data = topicData[topicIndex]
            }
        }
        value = a.getInputTargetBlock("DATA") ? a.getInputTargetBlock("DATA").isShadow_ ? value : "str(" + value + ")" : ""

        
        return `  IOT.SetIOTDataStr(${port},"${data}",${value})\r\n`
    };

    Blockly.Python.extSensor_GetAirQuality = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        
        return [`sensor.GetAirQuality(${port})`, 1]
    };

    
    Blockly.Python.extSensor_GetRainfall = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        
        return [`sensor.GetRainfall(${port})`, 1]
    };
    Blockly.Python.extSensor_GetSoilmoisture = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        
        return [`sensor.GetSoilmoisture(${port})`, 1]
    };
    
    Blockly.Python.extSensor_SetPump = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let status = a.getFieldValue("SWITCH");
        
        return `  sensor.SetPump(${port},${status})\r\n`
    };
    Blockly.Python.extSensor_M5_GetRFID = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return [`sensor.GetRFID522(${port})`, 1]
    };
    Blockly.Python.extSensor_M5_ReadRFIDData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        return [`sensor.ReadRFID522(${port})`, 1]
    };
    Blockly.Python.extSensor_M5_WriteRFIDData = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return `  sensor.WriteRFID522(${port},${value})\r\n`
    };
    Blockly.Python.extSensor_ReadRFID522Sector = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let quhao = a.getFieldValue("QUHAO");
        let kuaihao = a.getFieldValue("KUAIHAO");
        
        return [`sensor.ReadRFID522Sector(${port},${quhao},${kuaihao})`,1]
    };
    Blockly.Python.extSensor_WriteRFID522Sector = function (a) {
        Blockly.Python.definitions_.SENSOR = "import sensor";
        let port = a.getFieldValue("SENSORPORT");
        let quhao = a.getFieldValue("QUHAO");
        let kuaihao = a.getFieldValue("KUAIHAO");
        let value = Blockly.Python.valueToCode(a, "DATA", 2);
        
        return `  sensor.WriteRFID522Sector(${port},${quhao},${kuaihao},${value})\r\n`
    };


    // 扩展： AI

    Blockly.Python.AI_sensor_setWaitForAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "  rcu.SetWaitForAICamData(" + arg1 + ",0)\r\n";
    };
    Blockly.Python.AI_sensor_setAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA");
        return "  rcu.SetAICamData(" + arg1 + ",0)\r\n";
    };
    Blockly.Python.AI_sensor_setAICamLED = function (a) {
        let status = a.getFieldValue("LEDSTATUS");
        return "  rcu.SetAICamLED(" + status + ")\r\n";
    };
    Blockly.Python.AI_sensor_getAICamDataColorDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataQR = function (a) {
        let arg1 = a.getFieldValue("COLOR6");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataBall = function (a) {
        let arg1 = a.getFieldValue("COLOR2");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataRoad = function (a) {
        let arg1 = a.getFieldValue("COLOR5");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataFaceDetect = function (a) {
        let arg1 = a.getFieldValue("COLOR3");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataImage = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataApriltag = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataGesture = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataTraffic = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataColorLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataFaceLearning = function (a) {
        let arg1 = a.getFieldValue("COLOR4");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamDataImageStudy = function (a) {
        let arg1 = a.getFieldValue("COLOR7");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamData = function (a) {
        let arg1 = a.getFieldValue("DATA1");
        return ["rcu.GetAICamData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_getAICamVoice = function (a) {
        let arg1 = a.getFieldValue("ORDER");
        return ["rcu.GetAICamVoice(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_setFaceRegister = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ID", 2);
        return "  rcu.SetFaceRegister(" + arg1 + ")\r\n"
    };
    Blockly.Python.AI_sensor_getFaceRegisterData = function (a) {
        let arg1 = Blockly.Python.valueToCode(a, "ID", 2);
        return ["rcu.GetFaceRegisterData(" + arg1 + ")", 1];
    };
    Blockly.Python.AI_sensor_setAICamData_setBall = function (a) {
        let ball = a.getFieldValue("BALL");
        return "  rcu.SetAICamData(4," + ball + ")\r\n";
    };
    Blockly.Python.AI_sensor_setAICamData_ColorRecognition = function (a) {
        let arg = a.getFieldValue("ColorRecognitionARG");
        return "  rcu.SetAICamData(9," + arg + ")\r\n";
    };
    Blockly.Python.AI_sensor_setAICamData_FaceRecognition = function (a) {
        let arg = a.getFieldValue("FaceRecognitionARG");
        return "  rcu.SetAICamData(10," + arg + ")\r\n";
    };
    Blockly.Python.AI_sensor_setAICamData_imageRecognition = function (a) {
        let arg = a.getFieldValue("ImageRecognitionARG");
        return "  rcu.SetAICamData(12," + arg + ")\r\n";
    };


    // 无线扩展

    Blockly.Python.extWireless_setRFPassWord = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "DATA", 2);
        return `  wireless.SetRFPassWord(${arg1}, ${arg2})\r\n`;
    };
    Blockly.Python.extWireless_setRFModuleByte = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = Blockly.Python.valueToCode(a, "DATA", 2);
        return `  wireless.SetRFModuleByte(${arg1}, ${arg2})\r\n`;
    };
    Blockly.Python.extWireless_getRFModuleByte = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`wireless.GetRFModuleByte(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteButton = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`wireless.GetRFModuleRemoteButton(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteCode = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        return [`wireless.GetRFModuleRemoteCode(${arg1})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteGravity = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("AXIS");
        return [`wireless.GetRFModuleRemoteGravity(${arg1}, ${arg2})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteRocker = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("DIRECTION");
        let arg3 = a.getFieldValue("AXIS");
        return [`wireless.GetRFModuleRemoteRocker(${arg1}, ${arg2}, ${arg3})`, 1];
    };
    Blockly.Python.extWireless_getRFModuleRemoteBit = function (a) {
        Blockly.Python.definitions_.WIRELESS = "import wireless";
        let arg1 = a.getFieldValue("SENSORPORT");
        let arg2 = a.getFieldValue("BTN");
        return [`wireless.GetRFModuleRemoteBit(${arg1}, ${arg2})`, 1];
    };




    Blockly.Python.extServo_SetServo = function (a, b, c) {
        let prot = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "  rcu.SetServo(" + prot + "," + angle + ")\r\n";
    };

    Blockly.Python.extServo_SetServoTime = function (a, b, c) {
        let prot = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetServoTime(" + prot + "," + angle + "," + time + ")\r\n";
    };

    Blockly.Python.extServo_SetMagneticServoDegreeTime = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  rcu.SetMagneticServoDegreeTime(${port},${angle},${time})\r\n`;
    };

    Blockly.Python.extServo_SetMagneticServoDegreeSpeed = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  rcu.SetMagneticServoDegreeSpeed(${port},${angle},${speed})\r\n`;
    };

    Blockly.Python.extServo_SetMagneticServoCodeMotor = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT");
        let codenum = Blockly.Python.valueToCode(a, "CODENUM", 16);
        let speed = Blockly.Python.valueToCode(a, "SPEED", 16);
        return `  rcu.SetMagneticServoCodeMotor(${port},${codenum},${speed})\r\n`;
    };

    Blockly.Python.extServo_SetSeeringEngine = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        return `  rcu.SetSeeringEngine(${port},${angle})\r\n`;
    };

    Blockly.Python.extServo_SetSeeringEngineTime = function (a, b, c) {
        let port = a.getFieldValue("SENSORPORT_TWO");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 16);
        let time = Blockly.Python.valueToCode(a, "TIME", 16);
        return `  rcu.SetSeeringEngineTime(${port},${angle},${time})\r\n`;
    };

    Blockly.Python.extServo_SetOneServo = function (a, b, c) {
        let prop = a.getFieldValue("SENSORPORT");
        let channel = Blockly.Python.valueToCode(a, "CHANNEL", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        let time = Blockly.Python.valueToCode(a, "TIME", 2);
        return "  rcu.SetOneServo(" + prop + "," + channel + "," + angle + "," + time + ")\r\n";
    };




    //   列表
    Blockly.Python.data_listHead = "LIST_"
    Blockly.Python.data_listcontents = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.Python.data_listHead + listname

        return [listname, 1]
    };
    Blockly.Python.data_addtolist = function (a) {
        let str = Blockly.Python.valueToCode(a, "ITEM", 2)

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return `  ${listname}.append(${str})\r\n`
    };

    Blockly.Python.data_deleteoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let line = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(line))) {
            let str = line.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                line = line + " - 1"
            } else {
                line = Number(line) > 0 ? Number(line) - 1 : 0;
            }
        } else {
            line = Number(line) > 0 ? Number(line) - 1 : 0;
        }
        return `  del ${listname}[${line}]\r\n`
    };

    Blockly.Python.data_deletealloflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname
        return `  del ${listname}[:]\r\n`
    };

    Blockly.Python.data_insertatlist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }


        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `  ${listname}.insert(${index}, ${item})\r\n`
    };
    Blockly.Python.data_replaceitemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }

        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `  ${listname}[${index}] = ${item}\r\n`
    };

    Blockly.Python.data_listcontainsitem = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${str} in ${listname}`, 2]
    };

    Blockly.Python.data_itemnumoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${listname}.index(${str})`, 1]
    };

    Blockly.Python.data_itemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let num = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(num))) {
            let str = num.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                num = num + " - 1"
            } else {
                num = Number(num) > 0 ? Number(num) - 1 : 0;
            }
        } else {
            num = Number(num) > 0 ? Number(num) - 1 : 0;
        }
        return [`${listname}[${num}]`, 1]
    };
    Blockly.Python.data_lengthoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return [`len(${listname})`, 1]
    };



    //运算
    Blockly.Python.operator_add = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2) || 1
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2) || 1
        return [`${NUM1} + ${NUM2}`, 2]
    };
    Blockly.Python.operator_subtract = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} - ${NUM2}`, 2]
    };
    Blockly.Python.operator_multiply = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} * ${NUM2}`, 2]
    };
    Blockly.Python.operator_divide = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} / ${NUM2}`, 2]
    };
    Blockly.Python.math_arithmetic = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "A", 2)
        let OP = a.getFieldValue("OP")
        let RANDOMEND = Blockly.Python.valueToCode(a, "B", 2)
        return [`${RANDOMSTART} ${OP} ${RANDOMEND}`, 2]
    };
    Blockly.Python.operator_random = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "FROM", 2)
        let RANDOMEND = Blockly.Python.valueToCode(a, "TO", 2)
        return [`rcu.GetRandom(${RANDOMSTART},${RANDOMEND})`, 1]
    };
    Blockly.Python.operator_lt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} < ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_equals = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} == ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_gt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} > ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_and = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} and ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_or = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} or ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_not = function (a) {
        let OPERAND = Blockly.Python.valueToCode(a, "OPERAND", 2)
        return [`not(${OPERAND})`, 2]
    };
    Blockly.Python.operator_mod = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} % ${NUM2}`, 2]
    };
    Blockly.Python.operator_round = function (a) {
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        return [`round(${NUM})`, 2]
    };
    Blockly.Python.operator_mathop = function (a) {
        Blockly.Python.definitions_.Math = "import math";
        let OPERATOR = a.getFieldValue("OPERATOR")
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        let str = ''
        if (OPERATOR === "abs") {
            str = `math.fabs(${NUM})`
        } else if (OPERATOR === "e ^") {
            str = `math.pow(math.e,${NUM})`
        } else if (OPERATOR === "10 ^") {
            str = `math.pow(10,${NUM})`
        } else {
            str = `math.${OPERATOR}(${NUM})`
        }
        return [str, 2]
    };

    Blockly.Python.operator_join = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        if(!a.getInputTargetBlock("STRING1").isShadow()){
            string1 = `str(${string1})`
        }

        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        if(!a.getInputTargetBlock("STRING2").isShadow()){
            string2 = `str(${string2})`
        }
        return [`"".join((${string1},${string2}))`, 1]
    };

    Blockly.Python.operator_letter_of = function (a) {
        let letter = Blockly.Python.valueToCode(a, "LETTER", 2)
        let string = Blockly.Python.valueToCode(a, "STRING", 2)
        if(a.getInputTargetBlock("LETTER").isShadow_){
            if (!isNaN(Number(letter))) {
                if (letter <= 0) {
                    letter = 0
                } else {
                    letter -= 1
                }
            } else {
                letter = 1
            }
        }

        return [`${string}[${letter}]`, 1]
    };

    Blockly.Python.operator_length = function (a) {
        let string = Blockly.Python.valueToCode(a, "STRING", 2)
        return [`len(${string})`, 1]
    };

    Blockly.Python.operator_contains = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        return [`${string2} in ${string1}`, 1]
    };
    Blockly.Python.operator_isStringSame = function (a) {
        let StringOne = Blockly.Python.valueToCode(a, "string_one", 3)
        let StringTwo = Blockly.Python.valueToCode(a, "string_two", 3)
        return [`rcu.isStringSame(${StringOne},${StringTwo})`, 1]
    };
    Blockly.Python.operator_strToNum = function (a) {
        let string = Blockly.Python.valueToCode(a, "STRING", 3) || ""
        return [`int(${string})`, 1]
    };
    Blockly.Python.operator_numToStr = function (a) {
        let num = Blockly.Python.valueToCode(a, "NUM", 3) || ""
        return [`str(${num})`, 1]
    };



    //部分模块转换

    Blockly.Python.text = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        // 单独判断扩展模块里得字符串输入
        if (a.getParent().type === "extSensor_SetDisplayLattice") {
            return [`"${textValue}"`, 1]
        } else {
            if (isNaN(textValue * 1)) {
                textValue = '"' + textValue + '"'
                return [textValue, 1]
            } else {
                return [textValue, 1]
            }
        }
    }

    Blockly.Python.textvalue = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        return ['"' + textValue + '"', 1]

    }

    Blockly.Python.math_integer = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.math_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };
    Blockly.Python.math_whole_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.jmd_time_menu = function (a) {
        let time = a.getFieldValue('TIME') || 'null'
        return [time, 1]
    };

    Blockly.Python.motor_speed_menu = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    };

    Blockly.Python.motor_angle_menu = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_two = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_three = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.show_lines_menu = function (a) {
        let lines = a.getFieldValue('LINES') || 'null'
        return [lines, 1]
    };
    Blockly.Python.play_folder_menu = function (a) {
        let foldername = a.getFieldValue('FOLDERNAME') || 'null'
        return [foldername, 1]
    };

    Blockly.Python.play_music_menu = function (a) {
        let musicname = a.getFieldValue('MUSICNAME') || 'null'
        return [musicname, 1]
    };

    Blockly.Python.colour_picker = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Red = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Orange = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Yellow = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Green = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Blue = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Indigo = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Purple = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_White = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.matrix = function (a) {
        let matrix = a.getFieldValue('MATRIX') || 'null'
        return [matrix, 1]
    };

    Blockly.Python.AI_city_menu = function (a) {
        let value = a.getFieldValue('CITYVALUE') || 'null'
        return ['"' + value + '"', 1]
    }

    Blockly.Python.AI_PostAngelValue = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }
    Blockly.Python.AI_PostAngelValue2 = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }







    // 变量
    Blockly.Python.variables = {};
    Blockly.Python.variablesHead = "VAR_";
    Blockly.Python.data_variable = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""

        varible = Blockly.Python.variablesHead + varible

        return [varible, Blockly.Python.ORDER_ATOMIC]
    };
    Blockly.Python.data_setvariableto = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `  ${varible} = ${num}\r\n`
    };
    Blockly.Python.data_changevariableby = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `  ${varible} += ${num}\r\n`
    };




    // 自制积木

    // %s 数字类型控件 argument_reporter_string_number
    // %d 布尔类型控件 argument_reporter_boolean


    Blockly.Python.procedures_definition = function (a) {
        let b = Blockly.Python.blockToCode(a.workspace.getBlockById(a.getChildren(a)[0].id))
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        return "def " + b + ":[GLOBAL]\r\n" + passEnd;
    };
    Blockly.Python.procedures_prototype = function (a) {
        // console.log('procedures_prototype', a)
        let fnName = a.getProcCode().replace(/%[sbn\s]|\s/ig, '').trim()
        let children = a.getChildren(a)
        let array = []
        for (let i = 0; i < children.length; i++) {
            if (a.workspace.getBlockById(children[i].id)) {
                let value = Blockly.Python.blockToCode(a.workspace.getBlockById(children[i].id))
                array.push(value[0])
            }
        }
        fnName += `(${array.join(',')})`

        return fnName;
    };
    Blockly.Python.argument_reporter_boolean = function (a) {
        // console.log('argument_reporter_boolean', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())
        return [text, 1];
    };
    Blockly.Python.argument_reporter_string_number = function (a) {
        // console.log('argument_reporter_string_number', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())

        return [text, 1];
    };

    Blockly.Python.procedures_call = function (a) {
        // console.log('procedures_call', a)

        let array = []
        let fnName = a.getProcCode().replace(/(%s|%b|%n)|\s/ig, '')

        for (let i = 0; i < a.inputList.length; i++) {
            if (a.inputList[i].name !== '') {
                let blocks = a.inputList[i].connection.targetBlock()
                if (blocks) {
                    let child = Blockly.Python.blockToCode(a.workspace.getBlockById(blocks.id))
                    if (Array.isArray(child)) {
                        var arg = child[0]
                        if (child[1] === 2 || child[1] === 99) {
                            arg = '(' + arg + ')'
                        }
                        if (!(/[^\s]/ig.test(child[0]))) {
                            array.push('"' + arg + '"')
                        } else {
                            array.push(arg)
                        }
                    } else {
                        array.push(child)
                    }
                } else {
                    array.push('False')
                }
            }
        }

        fnName += `(${array.join(',')})`

        return `  ${fnName}\r\n`;
    };


}

export {
    toPython_C6
}
